'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function DiscoveryPage() {
	const router = useRouter();

	useEffect(() => {
		router.push('/discover/trending');
	}, [router]);

	return null;
}
